const evaluateAppMessage = ({ app, step }) => {
  const actionId = step?.actionId;
  const appName = app?.name;

  if (!actionId) {
    return appName || '';
  }

  const actions = app?.actions || [];
  if (!actions || actions.length === 0) {
    return appName || '';
  }

  const action = actions.find((a) => a?.id === actionId) || null;
  return action?.name || appName || '';
};

export default evaluateAppMessage;
